import { apiRequest } from 'utils/request';

// One question, before anything else: who is asking? The browser holds the
// answer in a cookie it will not show us, so the only way to know is to ask the
// API - a 200 carries `{ id }`, a 401 means the login screen.
//
// This used to be a token dance: read localStorage, POST the refresh token,
// store the new access token, set a default header. All of it is gone because
// there is nothing to store - the cookie travels by itself and the server
// renews its expiry on this very request. Logging in on another tab, or being
// revoked by an administrator, needs no code here: the cookie either works or
// it does not.
//
// It is asked twice, and the second attempt is the price of asking at all.
// Master read its token out of localStorage - synchronously, no request - so a
// network that was down could not sign anybody out. We boot by asking, and a
// socket that dies mid-question is not an answer: `error.response` is axios
// saying the server replied, and only its absence is worth asking again. A 401
// is an answer, and is believed the first time.
//
// Measured rather than imagined: in the run of 2026-08-12 one persona of 88
// caught an ERR_CONNECTION_RESET on this exact request and landed on the login
// screen holding a cookie that was still perfectly valid.
const ATTEMPTS = 2;

// `{ id, account_id }` - who is asking, and where they are standing.
//
// The account is here because the collections the boot fetches name it in their
// URL, and this is the request that runs before any of them. It is handed
// straight to BOOT and stored nowhere: it cannot come out of `state.users`,
// since that slice is filled by the very requests that need it. The header goes
// on reading the account off the caller's row, as it did.
export const whoAmI = async () => {
  for (let attempt = 1; ; attempt += 1) {
    try {
      const response = await apiRequest('/users/me/');
      return response.data;
    } catch (error) {
      if (error.response || attempt === ATTEMPTS) {
        throw error;
      }
    }
  }
};
